import classNames from "classnames";
import PropTypes from "prop-types";
import { SpinnerCircularFixed } from "spinners-react";
import styles from "./button.module.css";
import {
  play,
  arrowRightLongIcon,
  leftWhiteArrow,
  footerTelegramIcon,
  yellowTelegramIcon,
  blackArrowRight,
  shareICon,
  shareFB,
  shareLI,
  shareLink,
  shareTT,
  playWhiteIcon,
  // AddIcon,
  UploadIcon,
  closeIcon,
  calenderIcon,
  mentorEdit,
  videoicon,
  zoomWhite,
  newPlayIcon,
  arrowLeftLong,
} from "../../images";

const VARIANT = {
  primary: styles.btnPrimary,
  secondary: styles.btnSecondary,
  white: styles.btnWhite,
  black: styles.btnBlack,
  transparent: "bg-transparent",
  disabled: styles.btnDisabled,
};

const SIZE = {
  normal: styles.btnNormal,
  full: styles.btnFull,
};

const OUTLINE = {
  black: styles.blackOutline,
  white: styles.whiteOutline,
  yellow: styles.yellowOutline,
  red: styles.redOutline,
};

const iconDirection = {
  video: styles.video,
  telegram: styles.video,
  yellowTelegram: styles.video,
};

const ICONS = {
  video: play,
  videoWhite: playWhiteIcon,
  blackArrow: arrowRightLongIcon,
  leftArrowLong: arrowLeftLong,
  whiteArrow: leftWhiteArrow,
  telegram: footerTelegramIcon,
  yellowTelegram: yellowTelegramIcon,
  blackArrowRight: blackArrowRight,
  shareICon: shareICon,
  shareFB: shareFB,
  shareTT: shareTT,
  shareLI: shareLI,
  shareLink: shareLink,
  // plus: AddIcon,
  upload: UploadIcon,
  close: closeIcon,
  calenderIcon: calenderIcon,
  mentorEdit: mentorEdit,
  videoicon: videoicon,
  zoomWhite: zoomWhite,
  watchVideo: newPlayIcon,
};

const Button = ({
  type = "button",
  variant = "primary",
  size,
  children = null,
  icon,
  className = "",
  outline = "",
  iconPosition = "before",
  loading,
  onClick,
  ...restProps
}) => {
  const classes = classNames(
    styles.btnContainer,
    SIZE[size],
    VARIANT[variant],
    outline && OUTLINE[outline],
    className
  );
  const renderIcon = () => {
    if (!icon) return null;
    return <img src={ICONS[icon]} alt="icon" />;
  };
  return (
    <button {...restProps} type={type} className={classes} onClick={onClick}>
      {loading ? (
        <SpinnerCircularFixed
          color={"#f8d210"}
          style={{ height: "30px" }}
          thickness={"150"}
        />
      ) : (
        <>
          {iconPosition === "before" && renderIcon()}
          {children}
          {iconPosition === "after" && renderIcon()}
        </>
      )}
    </button>
  );
};

export default Button;

Button.propTypes = {
  variant: PropTypes.string,
  outline: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  size: PropTypes.string,
  loading: PropTypes.bool,
  iconPosition: PropTypes.oneOf(["before", "after"]),
};
